import { TableHeader, TableHead, TableRow } from "@/v2/shared/shadcn-ui/table";
import { EditableTableField } from "./EditableTable.model";

export interface EditableTableHeaderProps {
  fields: EditableTableField[];
  showToggle?: boolean;
}

export function EditableTableHeader({
  fields,
  showToggle = true,
}: EditableTableHeaderProps) {
  return (
    <TableHeader>
      <TableRow className="h-[32px]">
        {showToggle && (
          <TableHead className="w-[32px] p-0 py-0 h-[31px]"></TableHead>
        )}
        {fields.map((field) => (
          <TableHead
            key={field.key}
            className={`${field.width} p-0 py-0 pl-2 h-[31px]`}
          >
            {field.label}
          </TableHead>
        ))}
        <TableHead className="w-[32px] p-0 py-0 h-[31px]"></TableHead>
      </TableRow>
    </TableHeader>
  );
}
